import React from "react";
import { Provider, ReactReduxContext } from "react-redux";
import { Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import store, { persiststore } from "../store";
import App from "../components/App";
import { Alert } from "antd";
import { Provider as AlertProvider } from "react-alert";
import history from "../history";

const options = {
  timeout: 5000,
  position: "top right",
};
const Root = () => {
  return (
    <Provider store={store} context={ReactReduxContext}>
      <PersistGate persistor={persiststore} loading={null}>
        <AlertProvider template={Alert} {...options}>
          <Router history={history}>
            <App store={store} context={ReactReduxContext} />
          </Router>
        </AlertProvider>
      </PersistGate>
    </Provider>
  );
};

export default Root;